import { forwardRef } from "react";
const SvgSortDownArrow = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M10.6666 11.3333L7.99998 14M7.99998 14L5.33331 11.3333M7.99998 14L7.99998 2" stroke="#6C738C" strokeWidth={1.33333} strokeLinecap="round" strokeLinejoin="round" /></svg>;
const ForwardRef = forwardRef(SvgSortDownArrow);
export default ForwardRef;